export const ARCADE_COOKIE_SUFFIX = 'MU';
export const LWR_COOKIE_SUFFIX = 'AD';

// These cookies contain info about when the session expires.
export const ARACHNE_XSRF_COOKIE_SOURCE = 'FH';
export const ARCADE_XSRF_COOKIE_SOURCE = 'FH_MU';
export const ARCADE_SESSION_COOKIE_SOURCE = 'RS_MU';
export const LWR_XSRF_COOKIE_SOURCE = 'FH_AD';

// NOTE: use all-lowercase for headers to match cookies hash keys
export const ARCADE_XSRF_TOKEN_HEADER = 'arcade-xsrf-token';
export const RP_TOKEN_SUFFIX_HEADER = 'rp-token-suffix';
export const XSRF_TOKEN_HEADER = 'xsrf-token';
export const LINE_OF_BUSINESS_COOKIE = 'OP_LOB';

export const ARACHNE_SESSION_COOKIES = [
  // NOTE: see https://wiki.audaxhealth.com/display/APSEC/Arachne+Session+Management
  ARACHNE_XSRF_COOKIE_SOURCE,
  'FD',
  'FS',
  'RS',
];
export const ARCADE_SESSION_COOKIES = [
  ARCADE_XSRF_COOKIE_SOURCE,
  'FD_MU',
  ARCADE_SESSION_COOKIE_SOURCE,
];
export const LWR_SESSION_COOKIES = [
  LWR_XSRF_COOKIE_SOURCE,
  'FD_AD',
  'FS_AD',
  'RS_AD',
];

export const DEFAULT_SESSION_DURATION_MSEC = 20 * 60 * 1000;

export const ALL_SESSION_COOKIE_NAMES = [
  ...ARACHNE_SESSION_COOKIES,
  ...ARCADE_SESSION_COOKIES,
  ...LWR_SESSION_COOKIES,
];

export const hasAuthCookie = (cookieNames: string[] = []) => {
  return (
    cookieNames.some((name) => LWR_SESSION_COOKIES.includes(name)) ||
    cookieNames.some((name) => ARACHNE_SESSION_COOKIES.includes(name))
  );
};

/** Gets the time in epoch msec that the session expires */
export function getSessionExpiryMsec() {
  try {
    return getExpiryFromCookie(getSessionExpiryCookie());
  } catch (ex) {
    return Date.now() + DEFAULT_SESSION_DURATION_MSEC;
  }
}

/** Parses the value from getSessionExpiryCookie, a ! delimited string */
function getExpiryFromCookie(cookie: string) {
  const [_, initializedAtSeconds, ttlSeconds] = cookie.split('!');
  const expiryMsec = (Number(initializedAtSeconds) + Number(ttlSeconds)) * 1000;
  return expiryMsec;
}

/** Finds the cookie in a RA/Advantage/Arachne compatible way.
 * @returns '755bda5f-1166-4dcb-a9b0-d505e4c5794a!1674767622!1200' for example
 */
export function getSessionExpiryCookie() {
  return document.cookie
    .split(/;\s+/)
    .find((key) => key.startsWith(ARACHNE_XSRF_COOKIE_SOURCE))
    .split('=')[1];
}
